import * as yup from 'yup'
import { dateYupOptional, dateYupRequired } from '../validators/dateYup'

export const datePage = propOverrides => {
  const props = {
    pageId: 'needed_page',
    fieldName: 'needed',
    required: true,
    label: 'label',
    hint: '',
    labelClassName: 'needed',
    action: {
      type: 'next'
    },
    ...propOverrides
  }

  return {
    id: props.pageId,
    validation: yup.object().shape({
      [props.fieldName]: props.required ? dateYupRequired() : dateYupOptional()
    }),
    fields: [
      {
        type: 'date',
        name: props.fieldName,
        label: props.label,
        hint: props.hint,
        labelClassName: props.labelClassName,
        overrideDefaultMinMax: true
      }
    ],
    action: props.action
  }
}
